function extendImage(image) {
  let width = image.width;
  let height = image.height;

  let scaleFactor = 10;
  let scaleWidth = width / 100 * scaleFactor;
  let scaleHeight = height / 100 * scaleFactor;

  let newWidth = width + (scaleWidth * 2);
  let newHeight = height + (scaleHeight * 2);

  let canvas = document.createElement('canvas');
  canvas.width = newWidth;
  canvas.height = newHeight;
  let ctx = canvas.getContext('2d');

  // Fill the canvas with transparent pixels
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.fillRect(0, 0, newWidth, newHeight);

  // Draw the original image in the center of the new canvas
  ctx.drawImage(image, scaleWidth, scaleHeight, width, height);

  // Create a new image from the canvas
  let extendedImage = new Image();
  extendedImage.src = canvas.toDataURL();

  return extendedImage;
}

export default extendImage;